/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createAdminProgramPeriodConfig } from '../fn/admin-program-period-configs/create-admin-program-period-config';
import { CreateAdminProgramPeriodConfig$Params } from '../fn/admin-program-period-configs/create-admin-program-period-config';
import { findOneAdminProgramPeriodConfig } from '../fn/admin-program-period-configs/find-one-admin-program-period-config';
import { FindOneAdminProgramPeriodConfig$Params } from '../fn/admin-program-period-configs/find-one-admin-program-period-config';
import { listAdminProgramPeriodConfigs } from '../fn/admin-program-period-configs/list-admin-program-period-configs';
import { ListAdminProgramPeriodConfigs$Params } from '../fn/admin-program-period-configs/list-admin-program-period-configs';
import { listQualitySectionConfigs } from '../fn/admin-program-period-configs/list-quality-section-configs';
import { ListQualitySectionConfigs$Params } from '../fn/admin-program-period-configs/list-quality-section-configs';
import { ProgramPeriodConfig } from '../models/program-period-config';
import { QualitySectionConfig } from '../models/quality-section-config';
import { updateAdminProgramPeriodConfig } from '../fn/admin-program-period-configs/update-admin-program-period-config';
import { UpdateAdminProgramPeriodConfig$Params } from '../fn/admin-program-period-configs/update-admin-program-period-config';

@Injectable({ providedIn: 'root' })
export class AdminProgramPeriodConfigsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `adminProgramPeriodConfigControllerListAdminProgramPeriodConfigs()` */
  static readonly AdminProgramPeriodConfigControllerListAdminProgramPeriodConfigsPath = '/admin/program-period-configs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listAdminProgramPeriodConfigs()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAdminProgramPeriodConfigs$Response(
    params?: ListAdminProgramPeriodConfigs$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<ProgramPeriodConfig>>> {
    return listAdminProgramPeriodConfigs(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listAdminProgramPeriodConfigs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAdminProgramPeriodConfigs(
    params?: ListAdminProgramPeriodConfigs$Params,
    context?: HttpContext
  ): Observable<Array<ProgramPeriodConfig>> {
    return this.listAdminProgramPeriodConfigs$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ProgramPeriodConfig>>): Array<ProgramPeriodConfig> => r.body)
    );
  }

  /** Path part for operation `adminProgramPeriodConfigControllerCreateAdminProgramPeriodConfig()` */
  static readonly AdminProgramPeriodConfigControllerCreateAdminProgramPeriodConfigPath =
    '/admin/program-period-configs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createAdminProgramPeriodConfig()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAdminProgramPeriodConfig$Response(
    params: CreateAdminProgramPeriodConfig$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ProgramPeriodConfig>> {
    return createAdminProgramPeriodConfig(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createAdminProgramPeriodConfig$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAdminProgramPeriodConfig(
    params: CreateAdminProgramPeriodConfig$Params,
    context?: HttpContext
  ): Observable<ProgramPeriodConfig> {
    return this.createAdminProgramPeriodConfig$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProgramPeriodConfig>): ProgramPeriodConfig => r.body)
    );
  }

  /** Path part for operation `adminProgramPeriodConfigControllerFindOneAdminProgramPeriodConfig()` */
  static readonly AdminProgramPeriodConfigControllerFindOneAdminProgramPeriodConfigPath =
    '/admin/program-period-configs/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findOneAdminProgramPeriodConfig()` instead.
   *
   * This method doesn't expect any request body.
   */
  findOneAdminProgramPeriodConfig$Response(
    params: FindOneAdminProgramPeriodConfig$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ProgramPeriodConfig>> {
    return findOneAdminProgramPeriodConfig(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findOneAdminProgramPeriodConfig$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findOneAdminProgramPeriodConfig(
    params: FindOneAdminProgramPeriodConfig$Params,
    context?: HttpContext
  ): Observable<ProgramPeriodConfig> {
    return this.findOneAdminProgramPeriodConfig$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProgramPeriodConfig>): ProgramPeriodConfig => r.body)
    );
  }

  /** Path part for operation `adminProgramPeriodConfigControllerUpdateAdminProgramPeriodConfig()` */
  static readonly AdminProgramPeriodConfigControllerUpdateAdminProgramPeriodConfigPath =
    '/admin/program-period-configs/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAdminProgramPeriodConfig()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAdminProgramPeriodConfig$Response(
    params: UpdateAdminProgramPeriodConfig$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ProgramPeriodConfig>> {
    return updateAdminProgramPeriodConfig(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateAdminProgramPeriodConfig$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAdminProgramPeriodConfig(
    params: UpdateAdminProgramPeriodConfig$Params,
    context?: HttpContext
  ): Observable<ProgramPeriodConfig> {
    return this.updateAdminProgramPeriodConfig$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProgramPeriodConfig>): ProgramPeriodConfig => r.body)
    );
  }

  /** Path part for operation `adminProgramPeriodConfigControllerListQualitySectionConfigs()` */
  static readonly AdminProgramPeriodConfigControllerListQualitySectionConfigsPath =
    '/admin/program-period-configs/{id}/qualitySectionConfigs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listQualitySectionConfigs()` instead.
   *
   * This method doesn't expect any request body.
   */
  listQualitySectionConfigs$Response(
    params: ListQualitySectionConfigs$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<QualitySectionConfig>>> {
    return listQualitySectionConfigs(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listQualitySectionConfigs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listQualitySectionConfigs(
    params: ListQualitySectionConfigs$Params,
    context?: HttpContext
  ): Observable<Array<QualitySectionConfig>> {
    return this.listQualitySectionConfigs$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<QualitySectionConfig>>): Array<QualitySectionConfig> => r.body)
    );
  }
}
